import { useContext } from 'react';
import styled, { css } from 'styled-components';
import createLinkRel from '~/helpers/createLinkRel';
import UrlContext from '~/helpers/UrlContext';
import getFontFamily from '~/helpers/getFontFamily';
import { getColorByName } from '~/helpers/getColors';

export const NavLinkStyledCss = css`
  text-decoration: none;
  display: inline-block;
  position: relative;
  padding: 0;
  font-family: ${(props) => getFontFamily(props.theme.header.navLinkFont)};
  font-size: ${(props) => props.theme.cta.primaryFontSize};
  line-height: ${(props) => props.theme.cta.primaryLineHeight};
  background: ${(props) =>
    getColorByName(props.theme, props.theme.header.bgColor)};
  color: ${(props) => props.theme.color.primary800};
  transition: opacity 0.25s ease-out;
  width: auto !important;
`;

const NavLinkStyled = styled.a`
  ${NavLinkStyledCss};
`;

/**
 * @param {NavLinkProps} props
 * @returns {React.ReactElement} The rendered component
 */
const NavLink = ({
  className = '',
  onClick,
  href,
  target = '_self',
  text,
  title = text,
}) => {
  const createUrl = useContext(UrlContext);
  return (
    <NavLinkStyled
      className={className}
      onClick={onClick}
      href={createUrl(href)}
      target={target}
      title={title}
      rel={createLinkRel(target)}
    >
      {text}
    </NavLinkStyled>
  );
};

export default NavLink;
